import type { AgentHarnessRun } from '../../ai/agent-harness/agent.run';

/**
 * Contracts for "Run now": an administrator starts one extension agent on one of its assigned Jobs, outside any Job event.
 * The run travels the normal pending-event, delivery and history path; only its event type marks it as manual.
 */

/**
 * The `eventType` a manual run records. It is not an `ExtensionAgentTrigger` on purpose: a definition cannot subscribe to it, so event routing never produces it.
 * Run history shows it verbatim, so it reads as a label rather than a code.
 */
export const EXTENSION_AGENT_MANUAL_EVENT = 'Manual Run';

/** The trigger value a run's context reports for `EXTENSION_AGENT_MANUAL_EVENT`, beside the `ExtensionAgentTrigger` values, so an agent can tell an administrator's Run now from a Job event. */
export const EXTENSION_AGENT_MANUAL_TRIGGER = 'manual';

/** Payload of `RunExtensionAgentNowCommand`. */
export interface RunExtensionAgentNowRequest {
    /** The agent definition id. */
    agentId: string;
    /** The assigned Job the run acts on. */
    entityId: string;
}

/** What the harness did with a manual run request. */
export enum ExtensionAgentRunNowStatus {
    /** A run was created and handed to delivery. */
    Started = 'started',
    /** The agent already has an active run on this Job; the request waits as a pending event and starts when that run ends. */
    Queued = 'queued',
}

/** Result of `RunExtensionAgentNowCommand`; `run` is present only when `status` is `Started`. */
export interface RunExtensionAgentNowResult {
    status: ExtensionAgentRunNowStatus;
    run?: AgentHarnessRun;
}
